import { API_URL } from '../config';

export const getValidImageUrl = (url) => {
  if (!url) return '';
  let parsedUrl = url;
  
  // If the database has localhost saved, replace it
  if (parsedUrl.includes('localhost:5000')) {
    parsedUrl = parsedUrl.replace(/http:\/\/localhost:5000/g, API_URL || '');
  }
  
  // If the database saved it as /public/uploads/ instead of /uploads/, fix it
  if (parsedUrl.includes('/public/uploads/')) {
    parsedUrl = parsedUrl.replace('/public/uploads/', '/uploads/');
  }
  
  // If it's a relative /uploads/ path, prefix with API_URL
  if (parsedUrl.startsWith('/uploads/')) {
    return `${API_URL}${parsedUrl}`;
  }
  
  return parsedUrl;
};
